import { type AssetMode } from '@air/analytics';

import { AssetModalViewMode } from '~/components/v2/store/features/asset-modal/slices/createAssetModalViewModeSlice';

export const DEFAULT_AMOUNT_OF_CUSTOM_FIELDS_TO_SHOW = 3;

export const SEARCH_WIDTH = 350;

export const AssetModalViewModeAnalyticsMap: Record<string, AssetMode> = {
  [AssetModalViewMode.View]: 'view',
  [AssetModalViewMode.Comment]: 'comment',
  [AssetModalViewMode.EditImage]: 'edit',
  [AssetModalViewMode.EditVideo]: 'edit-video',
};
